import React, { Fragment, useRef } from 'react';

// Components

import InstructionalText from '../../components/ssap/notifications/InstructionalText';

// Utils

import { normalizeStringToBooleanValue } from '../../utils/normalize/normalizeStringToBooleanValue';


const Checkbox = props => {

    const handleValueChange = e => {
        const { dataset: { value } } = e.currentTarget;
        props.inputActions.handleFieldChange(!normalizeStringToBooleanValue(value), valueToPass);
    };

    const keyPress = e => {
        const isEnterOrSpace = e.key === ' ' || e.key === 'SpaceBar' || e.key === 'Enter' || e.keyCode === 32 || e.keyCode === 13;
        if (isEnterOrSpace) {
            handleValueChange(e);
        }
    };

    const {
        inputData: {
            checked,
            classes,
            id,
            isInputRequired,
            name,
            type,
            valueToPass,
            disabled
        },
        label: {
            dataInstructions,
            dataInstructionsAnchor: anchor,
            replacements,
            text,
            labelClass,
            instructionsViaPortal: [
                isPortal,
                portalMargin
            ] = [],
            skipParsing,
            additionalText = null
        }
    } = props;

    // If it is needed multi-location react portal anchor may be implemented.
    // For a while there are only 2 usages for it (here and in RadioButtons)
    const reactPortalAnchor = useRef();

    return (
        <Fragment>
            <div className = { `gi-component gi-${ type } ${ classes }` } >
                <Fragment>
                    <input
                        id = { id }
                        name = { name }
                        className = { `usa-checkbox__input gi-${ type }__input required-${ isInputRequired }` }
                        type = 'checkbox'
                        role = 'checkbox'
                        aria-checked = { checked }
                        aria-required = { isInputRequired }
                        data-value = { checked }
                        aria-labelledby = { `${ type }_${ id }_label` }
                        onKeyPress = { keyPress }
                        checked = { checked === null ? '' : checked }
                        onChange = { () => {} }
                        disabled = { disabled }
                        value = { checked === null ? '' : checked }
                    />

                    <label
                        id = { `${ type }_${ id }_label` }
                        htmlFor = { id }
                        data-testid = { id }
                        data-value = { checked === null ? '' : checked }
                        onClick = { handleValueChange }
                        className = { `usa-checkbox__label gi-${ type }__label ${ labelClass && labelClass.join(' ') }` }
                    >
                        { text }
                        {
                            dataInstructions &&

                            <InstructionalText
                                anchor = { anchor }
                                disabled = { disabled }
                                Component = {
                                    <span data-instructions = { dataInstructions } />
                                }
                                replacements = { replacements }
                                reactPortalAnchor = { isPortal ? reactPortalAnchor : { current: null } }
                                skipParsing = { skipParsing }
                            />
                        }
                    </label>

                    {
                        additionalText && (
                            <p className = 'padding-left-4' >
                                { additionalText }
                            </p>
                        )
                    }
                </Fragment>
            </div>

            <div
                ref = { reactPortalAnchor }
                style={ {
                    'marginTop': portalMargin
                } }
            />
        </Fragment>
    );
};

export default Checkbox;
